import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "./../services/http";
import config from "./../config";
import TablaPendientesID from '../modules/PendientesID/components/TablaPendientesID';
import DescargarArchivo from "./../modules/PendientesID/components/DescargarArchivo";
import HeaderComponent from "./../modules/Shared/components/HeaderComponent";
import { Tabs, message, Upload } from 'antd';
import { InboxOutlined, ArrowLeftOutlined } from '@ant-design/icons';
const { Dragger } = Upload;

const PendienteID = ({ obra }) => {

    const [loading, setLoading] = useState(false);
    const [defaultKey, setDefaultKey] = useState(1);
    const [pendientes, setPendientes] = useState([]);
    const navigate = useNavigate();

    const token = localStorage.getItem('token') || null;
    const props = {
        name: 'readPendingId',
        multiple: false,
        action: `${config.server}/api/v1/payments/pendingToRelationship/read-xlsx/${obra.id}`,
        headers: {
            "Authorization": `Bearer ${token}`
        },
        accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                setDefaultKey(2);
                message.success(`${info.file.name} archivo procesado exitosamente.`);
                DeleteFile(info.file.response.path);

            } else if (status === 'error') {
                message.error(`${info.file.name} error al cargar el archivo.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    useEffect(() => {
        if (defaultKey === 2) GetPendientesId();
    }, [defaultKey]);

    const updatePendingId = (params) => {
        GetPendientesId();
    }

    const GetPendientesId = async () => {
        setLoading(true);
        try {
            const response = await axios.HTTP_GET(`/api/v1/payments/pendingId/${obra.id}`);
            const relacionesConKey = response.map((pending, index) => ({
                ...pending,
                key: pending.id || index, // Usa 'id' si existe, o genera una clave única
            }));
            if (response) setPendientes(relacionesConKey);
            setLoading(false);
        } catch (error) {
            console.log("Error - GetPendientesId: ", error);
            setLoading(false);
        }
    }

    const DeleteFile = async (path) => {
        try {
            const response = await axios.HTTP_POST("/api/v1/extras/delete-document", { path: path });
        } catch (error) {
            console.log("Error - GetPendientesId: ", error);
            setLoading(false);
        }
    }

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    const itemsTab = [{
        label: "Examinar archivo",
        key: 1,
        children: <>
            <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Haga clic o arrastré el archivo en el área para cargarlo</p>
                <p className="ant-upload-hint">
                    El archivo debe contener un formato específico, si no será rechazado por el servidor.
                </p>
            </Dragger>
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2rem" }}>
                <DescargarArchivo
                    label="Descargar plantilla"
                    size="middle"
                    path="static/plantilla_pendienteId.xlsx"
                    nameFile="plantilla_pendienteId.xlsx"
                />
            </div>
        </>
    }, {
        label: "Presupuesto ID",
        key: 2,
        children: <>
            <TablaPendientesID pendientes={pendientes} loading={loading} updatePendingId={updatePendingId} />
        </>
    }];

    return (
        <>
            <HeaderComponent title={`Presupuesto ID - ${obra.nombre_obra}`} />

            <Tabs
                activeKey={defaultKey}
                defaultActiveKey="1"
                tabPosition={"top"}
                style={{ marginTop: 10 }}
                items={itemsTab}
                onTabClick={(key) => setDefaultKey(key)}
            />
        </>
    )
}

export default PendienteID;